"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const botones_1 = require("../../../botones");
const modal_1 = require("../../../modal");
const table_1 = require("../../../table");
const text_1 = require("../../simpleGrid/text");
class ArrayCell extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { value, columns, itemToString, separator, string } = this.props;
        const toString = itemToString || text_1.cellToText;
        const text = (value || []).map(x => toString(x)).join(separator || ", ");
        return (React.createElement("div", { style: { overflowX: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, (value && value.length > 0) ?
            (React.createElement("span", null,
                React.createElement(botones_1.Link, { style: "success", iconClass: "fa fa-list", onClick: () => this.setState({ showListModal: true }) }),
                text,
                this.state.showListModal &&
                    React.createElement(ArrayCellModal, Object.assign({}, this.props, { onClose: () => this.setState({ showListModal: false }) })))) : React.createElement("span", null)));
    }
}
exports.ArrayCell = ArrayCell;
/**Modal que muestra el contenido del arreglo */
class ArrayCellModal extends React.PureComponent {
    render() {
        const columns = this.props.columns || [
            {
                cell: x => text_1.cellToText(x),
                title: ""
            }
        ];
        const header = React.createElement("tr", null, columns.map(x => x.title).map(x => React.createElement("th", null, x)));
        const row = (item) => React.createElement("tr", null, columns.map(x => x.cell(item)).map(x => React.createElement("td", null, x)));
        const rows = (this.props.value || []).map(row);
        return (React.createElement(modal_1.Modal, { buttons: [], onClose: this.props.onClose, title: "Detalle" },
            React.createElement(table_1.Table, { header: header, items: rows })));
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/cells/arraycell.js
// module id = 2215
// module chunks = 0